
import Button from '@/shared/components/button';
import {localize} from '@/shared/services/i18n';
import CookieAgreement from './CookieAgreement';

import {CookieConsentInitialProps} from '../types';

const CookieConsentInitial = ({
  onCustomizeSettings,
  onAcceptAll,
}: CookieConsentInitialProps) => {
  return (
    <div
      data-test-id="cookie-consent-modal"
      className="flex max-h-[inherit] flex-col rounded-2lg bg-white px-7 py-8 text-center"
    >
      <h4 className="mb-4 font-semibold text-black text-lg">
        {localize('cookie_consent_initial_title')}
      </h4>
      <CookieAgreement className="mb-7 text-base" />
      <div className="flex flex-col gap-3 sm:flex-row">
        <Button onClick={onCustomizeSettings} variant="system">
          {localize('cookie_consent_customize_settings')}
        </Button>
        <Button variant="system" onClick={onAcceptAll}>
          {localize('cookie_consent_accept_all')}
        </Button>
      </div>
    </div>
  );
};

export default CookieConsentInitial;
